import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {MatDialogRef} from "@angular/material/dialog";
import {AddOrUpdateBusinessOptions} from "./options/add-or-update-business.options";
import {DataResponse} from "../../../../network/service/data.response";
import {SnackBarUtil} from "../../../../util/snack.bar.util";
import {DetailsOptions, DynamicField} from '../details/options/details.options';
import {DetailsComponent} from '../details/details.component';

@Component({
  selector: 'app-add-or-update-business',
  standalone: false,
  templateUrl: './add-or-update-business.component.html',
  styleUrls: ['./add-or-update-business.component.scss']
})
export class AddOrUpdateBusinessComponent extends BaseComponent implements OnInit {
  addOrUpdateBusinessOptions = new AddOrUpdateBusinessOptions();
  title?: any;
  standardCode?: any;
  priority?: any;
  uniqueIdentifier?: any;
  iconFile?: any;
  icon?: any;
  details?: any;
  parentId?: any;

  constructor(injector: Injector, private matDialogRef: MatDialogRef<AddOrUpdateBusinessComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.title = this.addOrUpdateBusinessOptions.business.Title;
    this.standardCode = this.addOrUpdateBusinessOptions.business.StandardCode;
    this.priority = this.addOrUpdateBusinessOptions.business.Priority;
    this.uniqueIdentifier = this.addOrUpdateBusinessOptions.business.UniqueIdentifier;
    this.parentId = this.addOrUpdateBusinessOptions.business.ParentId;
    this.icon = this.addOrUpdateBusinessOptions.business.Icon;
    this.details = this.addOrUpdateBusinessOptions.business.Details;
    if (this.icon) {
      this.iconFile = [{
        name: this.addOrUpdateBusinessOptions.business.Icon
      }];
    }
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
    if (this.isRequiredFieldsFilled(this.title)) {
      this.upload((this.iconFile ?? [])[0], (fileId: string) => {
        this.icon = fileId;
        (this.addOrUpdateBusinessOptions.business.BusinessId !== undefined ? this.serviceApi.updateBusinesses(this.addOrUpdateBusinessOptions.business.BusinessId, {
          Title: this.title,
          StandardCode: this.standardCode,
          Priority: this.priority,
          UniqueIdentifier: this.uniqueIdentifier,
          Icon: this.icon,
          Details: this.addOrUpdateBusinessOptions.business.Details
        }) : this.serviceApi.createBusinesses({
          Title: this.title,
          ParentId: this.addOrUpdateBusinessOptions.parentId,
          StandardCode: this.standardCode,
          Priority: this.priority,
          UniqueIdentifier: this.uniqueIdentifier,
          Icon: this.icon,
          Details: this.addOrUpdateBusinessOptions.business.Details
        })).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            this.addOrUpdateBusinessOptions.onInsertOrUpdateFinished();
            this.noAction();
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      });
    }
  }

  upload(file: any, callback: any) {
    if (file) {
      if (file instanceof File) {
        let formData = new FormData();
        formData.append('File', file);
        this.serviceApi.upload(formData).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            callback(res.data.dataValues.FileId);
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        callback(file.name);
      }
    } else {
      callback(null);
    }
  }

  onDetailClicked() {
    const fieldMeta: Record<string, Partial<DynamicField>> = {
      Logo: {
        type: 'file-chooser',
        isMultiple: false
      },
      Phone: {
        type: 'text',
        required: true
      },
      FirstPage: {
        type: 'text',
        required: true
      },
      QRInfo: {
        type: 'object',
        objectFields: [
          {
            label: 'QRIcon',
            type: 'file-chooser',
            isMultiple: false
          },
          {
            label: 'GradientColor1',
            type: 'color'
          },
          {
            label: 'GradientColor2',
            type: 'color'
          },
          {
            label: 'BackgroundColor',
            type: 'color'
          }
        ]
      },
      Slogan: {type: 'text'},
      Videos: {
        type: 'file-chooser',
        isMultiple: true
      },
      AboutUs: {
        type: 'editor',
        required: true
      },
      Address: {type: 'text'},
      Landing: {
        type: 'object',
        objectFields: [
          {
            label: 'Gallary',
            type: 'object',
            objectFields: [
              {
                label: 'Image_1',
                type: 'file-chooser',
                isMultiple: false
              },
              {
                label: 'Image_2',
                type: 'file-chooser',
                isMultiple: false
              },
              {
                label: 'Image_3',
                type: 'file-chooser',
                isMultiple: false
              },
              {
                label: 'Image_4',
                type: 'file-chooser',
                isMultiple: false
              },
              {
                label: 'Image_5',
                type: 'file-chooser',
                isMultiple: false
              }
            ]
          },
          {
            label: 'SiteSlogan',
            type: 'editor'
          },
          {
            label: 'ServiceTimeSheet',
            type: 'object',
            objectFields: [
              {
                label: 'Background',
                type: 'file-chooser',
                isMultiple: false
              },
              {
                label: 'TimeSheetText',
                type: 'text'
              }
            ]
          },
          {
            label: 'SiteSloganDetails',
            type: 'object',
            objectFields: [
              {
                label: 'Image_1',
                type: 'file-chooser',
                isMultiple: false
              },
              {
                label: 'Image_2',
                type: 'file-chooser',
                isMultiple: false
              },
              {
                label: 'Slogan_1',
                type: 'text'
              },
              {
                label: 'Slogan_2',
                type: 'text'
              },
              {
                label: 'Slogan_3',
                type: 'text'
              },
              {
                label: 'Slogan_4',
                type: 'text'
              },
              {
                label: 'SloganDescription_1',
                type: 'text'
              },
              {
                label: 'SloganDescription_2',
                type: 'text'
              },
              {
                label: 'SloganDescription_3',
                type: 'text'
              },
              {
                label: 'SloganDescription_4',
                type: 'text'
              }
            ]
          }
        ]
      },
      IsActive: {
        label: 'Status',
        type: 'checkbox'
      },
      ActiveOrdering: {
        label: 'ActiveOrdering',
        type: 'checkbox'
      },
      LogoFont: {
        type: 'file-chooser',
        isMultiple: false
      },
      LogoText: {
        type: 'file-chooser',
        isMultiple: false
      },
      Payments: {
        type: 'array',
        arrayFields: [
          {
            label: 'PSP',
            type: 'text'
          },
          {
            label: 'MerchantId',
            type: 'text'
          },
          {
            label: 'Percentage',
            type: 'number'
          }
        ]
      },
      ContactUs: {type: 'editor'},
      TimeSheets: {
        type: 'array',
        arrayFields: [
          {
            label: 'DayCode',
            type: 'number'
          },
          {
            label: 'StartTime',
            type: 'text'
          },
          {
            label: 'EndTime',
            type: 'text'
          },
          {
            label: 'IsActive',
            type: 'checkbox'
          }
        ]
      },
      Certificates: {
        type: 'array',
        arrayFields: [
          {
            label: 'URI',
            type: 'text'
          },
          {
            label: 'Type',
            type: 'text'
          }
        ]
      },
      SocialMedias: {
        type: 'array',
        arrayFields: [
          {
            label: 'URI',
            type: 'text'
          },
          {
            label: 'Type',
            type: 'text'
          }, {
            label: 'Title',
            type: 'text'
          }
        ]
      },
      Events: {
        type: 'array',
        arrayFields: [
          {
            label: 'Title',
            type: 'text'
          },
          {
            label: 'ButtonTitle',
            type: 'text'
          },
          {
            label: 'Description',
            type: 'editor'
          },
          {
            label: 'FileId',
            type: 'file-chooser',
            isMultiple: false
          }
        ]
      },
      AddressLatitude: {type: 'text'},
      AddressLongitude: {type: 'text'},
      SloganDescription: {type: 'text'},
      LogoBackgroundColor: {type: 'color'},
      LogoBackgroundOpacity: {type: 'text'}
    };
    const detailsSource = this.addOrUpdateBusinessOptions.business.Details || {};
    const configFields: DynamicField[] = Object.keys(fieldMeta).map(key => {
      let meta = fieldMeta[key] || {};
      let value = detailsSource[key] ?? '';
      let type = meta.type || 'text';
      let isMultiple = meta.isMultiple || false;
      let required = meta.required || false;
      let options = meta.options;
      if (type === 'file-chooser' && typeof value === 'string') {
        value = [{name: value}];
      }
      if (type === 'file-chooser' && Array.isArray(value)) {
        value = value.map(v => (typeof v === 'string' ? {name: v} : v));
      }
      // Handle JSON objects and arrays for textarea fields
      if (type === 'textarea' && (typeof value === 'object' || Array.isArray(value))) {
        value = JSON.stringify(value, null, 2);
      }
      // Handle object fields
      if (type === 'object' && meta.objectFields) {
        const objectValue = value || {};
        const processedObjectFields = meta.objectFields.map(objField => {
          let objValue = objectValue[objField.label] ?? '';
          let objType = objField.type || 'text';
          let objIsMultiple = objField.isMultiple || false;
          let objRequired = objField.required || false;
          let objOptions = objField.options;
          if (objType === 'file-chooser' && typeof objValue === 'string') {
            objValue = [{name: objValue}];
          }
          if (objType === 'file-chooser' && Array.isArray(objValue)) {
            objValue = objValue.map(v => (typeof v === 'string' ? {name: v} : v));
          }
          // Handle nested object fields
          if (objType === 'object' && objField.objectFields) {
            const nestedValue = objValue || {};
            const processedNestedFields = objField.objectFields.map(nestedField => {
              let nestedObjValue = nestedValue[nestedField.label] ?? '';
              let nestedObjType = nestedField.type || 'text';
              let nestedObjIsMultiple = nestedField.isMultiple || false;
              let nestedObjRequired = nestedField.required || false;
              let nestedObjOptions = nestedField.options;
              if (nestedObjType === 'file-chooser' && typeof nestedObjValue === 'string') {
                nestedObjValue = [{name: nestedObjValue}];
              }
              if (nestedObjType === 'file-chooser' && Array.isArray(nestedObjValue)) {
                nestedObjValue = nestedObjValue.map(v => (typeof v === 'string' ? {name: v} : v));
              }
              return {
                label: nestedField.label,
                type: nestedObjType,
                value: nestedObjValue,
                required: nestedObjRequired,
                isMultiple: nestedObjIsMultiple,
                options: nestedObjOptions
              };
            });
            return {
              label: objField.label,
              type: objType,
              value: objValue,
              required: objRequired,
              isMultiple: objIsMultiple,
              options: objOptions,
              objectFields: processedNestedFields
            };
          }
          return {
            label: objField.label,
            type: objType,
            value: objValue,
            required: objRequired,
            isMultiple: objIsMultiple,
            options: objOptions
          };
        });
        return {
          label: key,
          type,
          value,
          required,
          isMultiple,
          options,
          objectFields: processedObjectFields
        };
      }
      // Handle array fields
      if (type === 'array' && meta.arrayFields) {
        const arrayValue = Array.isArray(value) ? value : [];
        // Process each item in the array to convert file-chooser fields
        const processedArrayValue = arrayValue.map(item => {
          const processedItem = {...item};
          meta.arrayFields?.forEach(arrayField => {
            if (arrayField.type === 'file-chooser') {
              const fieldValue = item[arrayField.label];
              if (typeof fieldValue === 'string' && fieldValue) {
                processedItem[arrayField.label] = [{name: fieldValue}];
              } else if (Array.isArray(fieldValue)) {
                processedItem[arrayField.label] = fieldValue.map(v =>
                  typeof v === 'string' ? {name: v} : v
                );
              } else if (!fieldValue) {
                processedItem[arrayField.label] = [];
              }
            }
          });
          return processedItem;
        });
        const processedArrayFields = meta.arrayFields.map(arrayField => {
          let arrayFieldType = arrayField.type || 'text';
          let arrayFieldIsMultiple = arrayField.isMultiple || false;
          let arrayFieldRequired = arrayField.required || false;
          let arrayFieldOptions = arrayField.options;
          return {
            label: arrayField.label,
            type: arrayFieldType,
            value: '',
            required: arrayFieldRequired,
            isMultiple: arrayFieldIsMultiple,
            options: arrayFieldOptions
          };
        });
        return {
          label: key,
          type,
          value: processedArrayValue,
          required,
          isMultiple,
          options,
          arrayFields: processedArrayFields
        };
      }
      return {
        label: key,
        type,
        value,
        required,
        isMultiple,
        options
      };
    });
    let detailsOptions = new DetailsOptions();
    detailsOptions.fields = configFields;
    detailsOptions.onDetailsSelected = (details: any) => {
      Object.keys(details).forEach(key => {
        if (!this.addOrUpdateBusinessOptions.business.Details) this.addOrUpdateBusinessOptions.business.Details = {};
        let value = details[key];
        // Handle array fields - ensure they are always arrays
        if (key === 'Payments' || key === 'TimeSheets' || key === 'Certificates' || key === 'SocialMedias' || key === 'Events') {
          if (!Array.isArray(value)) {
            value = [];
          }
        }
        this.addOrUpdateBusinessOptions.business.Details[key] = value;
      });
      this.addOrUpdateBusinessOptions.business.Details = details;
      this.details = details; // Update the local details property
    };
    let detailsComponent = this.matDialog.open(DetailsComponent, {
      height: 'auto',
      width: '100%',
      panelClass: 'responsive-dialog'
    });
    detailsComponent.componentInstance.detailsOptions = detailsOptions;
    detailsComponent.componentInstance.configData = this.addOrUpdateBusinessOptions.business.Details;
  }
}

